export class NoTagData extends Error {}